import { TypesColor } from "types/theme";

const commonColor = {
  sidenav: {
    main: "#0A67F3",
    state: "#00B9FF",
  },

  coloredShadows: {
    primary: "#e91e62",
    secondary: "#110e0e",
    info: "#00bbd4",
    success: "#4caf4f",
    warning: "#ff9900",
    error: "#f44336",
    light: "#adb5bd",
    dark: "#404040",
  },

  inputBorderColor: "#d2d6da",

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },

  transparent: {
    main: "rgba(0, 0, 0, 0)",
    // main: "transparent",
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#00B9FF",
  },

  grey: {
    100: "#f8f9fa",
    200: "#f0f2f5",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: "#6c757d",
    700: "#495057",
    800: "#343a40",
    900: "#212529",
  },

  gradients: {
    primary: {
      main: "#0A67F3",
      state: "#00B9FF",
    },

    secondary: {
      main: "#343a40",
      state: "#adb5bd",
    },
    success: {
      main: "#ABE098",
      state: "#43CC14",
    },
    error: {
      main: "#F25555",
      state: "#F21818",
    },
    sidenav: {
      main: "#0A67F3",
      state: "#00B9FF",
    },
    warning: {
      main: "#FFA726",
      state: "#FB8C00",
    },
  },
  badgeColors: {
    primary: {
      background: "#f8b3ca",
      text: "#cc084b",
    },

    secondary: {
      background: "#d7d9e1",
      text: "#6c757d",
    },

    info: {
      background: "#aecef7",
      text: "#095bc6",
    },

    success: {
      background: "#bce2be",
      text: "#00a556",
    },

    warning: {
      background: "#ffd59f",
      text: "#c87000",
    },

    error: {
      background: "#fcd3d0",
      text: "#FE2626",
    },

    light: {
      background: "#ffffff",
      text: "#c7d3de",
    },

    dark: {
      background: "#8097bf",
      text: "#1e2e4a",
    },
  },
};

export const colorsDark: TypesColor = {

  blue: {
    light: '#4F89D6',
    main: '#0052A3',
    dark: '#00377133',
    darker: '#001e3e'
  },

  transparent: {
    main: commonColor.transparent.main,
  },
  black: {
    light: commonColor.black.light,
    main: commonColor.black.main,
    focus: commonColor.black.focus,
  },

  grey: commonColor.grey,
  coloredShadows: commonColor.coloredShadows,
  inputBorderColor: commonColor.inputBorderColor,
  tabs: commonColor.tabs,
  sidenav: commonColor.sidenav,
  badgeColors: commonColor.badgeColors,

  background: {
    default: "#121212",
    sidenav: "#404040",
    sidenavDark: "#121212",
    card: "#292929",
    paper: "#121212",
  },

  backgroundLight: {
    primary: "#000000",
    secondary: "#FFFFFF",
    sidenav: "#E4EDFF",
    sidenavBorder: "#83B9F9",
    sideNavBG: "#6C727F",
    sideNavHighlightBG: "#003771",
    sideNavLogoBg: "#003771",
    sideNavBgHover: "#EFF6FF",
    sideNavExpandBg: "#DAE3F4",
    globalSearch: "#6C727F",
    globalSearchBorder: "#39ACE7",
    globalSearchPlaceHolder: "#A9ADCB",
    dark: "#003771",
    icon: "#39ACE7",
  },

  textLight: {
    main: "#fff",
    secondary: "#0784B5",
    dark: "#003771",
    light: "#FFFFFF",
    sideNavMain: "#39ACE7",
    sideNavDark: "#003771",
  },

  Header: {
    background: "#000",
    text: "#FFFFFF",
    textSecondary: "#a9adcb", // local time color
    userMenuBg: "#003771",
    UserMenuAvatarBg: "#0079A6",
    UserMenuAvatarText: "#FFFFFF",
    TabPagerHeaderBg: "#F3F8FF",
    TabPageHeaderBorder: "#003771"
  },

  page: {
    title: "#fff"
  },

  landingPageTile: {
    background: "#000",
    listBackground: "#E4EDFF",
    listitemColor: "#003771",
    text: "#ffffff",
    parentTagline: "rgba(255,255,255,0.7)",
    ExpandIcon: "#ffffff",
    divider: "#003771"
  },

  landingPage: {
    background: "#fff",           // landing page background
    welcomeText: "#0F149C",       // "Welcome aboard, Power User All"
    subtitleText: "#EB3323",      // "Your PepWise journey starts here!"
    labelText: "#000000",         // "User Role", "Sector", "Last Login"
    valueText: "#0F149C",         // "PepWise System User", "All", date/time
    divider: "#003771",           // Thin line below "Recently Used Dashboards"
    sectionTitle: "#0F149C",      // "Recently Used Dashboards"
  },

  scrollbar: {
    background: "#f1f1f1",
    thumb: "#003771",
  },

  dropdown: {
    background: "#003771",
    bgColorDisabled: "rgba(113, 117, 143, 0.05)",
    menuItemBackground: "#E4EDFF",
    menuItemText: "#003771",
    menuItemHover: "#003771",
    menuItemHoverText: "#FFFFFF",
    menuItemSelected: "#005092",
    checkBox: "#009BD8",
    border: "#003771"
  },

  queryBuilder: {
    background: '#FBFDFF',
    tableCellBackground: '#FFFFFF',
    text: '#000000',
    title: '#00366E',
    subText: '#71758F',
    primary: '#009BD8',
    cardBackground: '#EFF6FF',
    dropdown: {
      background: '#EFF6FF',
    }
  },

  moreOptionDropdown: {
    background: "#EFF6FF",
    menuItemBackground: "#E4EDFF",
    menuItemText: "#000",
    menuItemHover: "#39ACE733 ",
    menuItemHoverText: "#000",
    deleteMenuItem: "#FE2626",
    chipBackground: "#39ACE733",
    chipText: "#003771",
  },

  DropdownV2: {
    background: "#E4EDFF",
    menuTextColor: "#003771",
    menuItemBackground: "#FBFDFF",
    menuItemText: "#000",
    menuItemSelectedBg: "#39ACE733",
    menuItemSelectedText: "#000",
    menuItemHover: "#F4F6F8 ",
    menuItemHoverText: "#000",
    tickColor: '#003771',
    borderColor: '#71758FCC',
    borderColorActive: '#003771',
    borderColorHover: '#39ACE7',
    dropdownIconDefault: '#39ACE7',
    dropdownIconActive: '#003771',
    mutedText: '#A9ADCB'
  },

  filterDropdown: {
    label: "#5B6B82",
    title: "#003771",

    fieldText: "#003771",
    fieldPlaceholder: "#5B6B82",
    fieldBackground: "#EFF6FF",
    fieldBorder: "#D8E3F2",
    fieldIcon: "#2F8EDB",
    fieldClearIcon: "#2F8EDB",

    panelBackground: "#FFFFFF",
    panelBorder: "#D8E3F2",

    searchIcon: "#5B6B82",
    searchText: "#003771",
    searchPlaceholder: "#5B6B82",
    searchBackground: "#FFFFFF",

    optionText: "#003771",
    optionHoverBackground: "#EEF5FF",

    checkboxBorder: "#2F8EDB",
    checkboxCheck: "#2F8EDB",
    checkboxBackground: "transparent",

    chipBackground: "#DCEEFF",
    chipText: "#1F5E9B",

    emptyText: "#5B6B82",
  },

  checkboxGroup: {
    title: "#003771",
    optionText: "#000000",
    checkboxBorder: "#39ACE7",
    checkboxCheckedBackground: "#39ACE7",
    checkboxCheckIcon: "#FFFFFF",
    checkboxUncheckedBackground: "transparent",
    disabledBorder: '#A9ADCB',
  },

  radioGroup: {
    title: "#003771",
    optionText: "#000000",
    radioBorder: "#39ACE7",
    radioCheckedBackground: "#39ACE7",
    radioCheckIcon: "#FFFFFF",
    radioUncheckedBackground: "transparent",
    disabledBorder: '#A9ADCB',
  },

  filterPanel: {
    panelBackground: "#FFFFFF",
    panelBorder: "rgba(0,0,0,0.08)",
    panelShadow: "0px 10px 30px rgba(0,0,0,0.12)",
    headerTitle: "#003771",
    sectionTitle: "#8AA0BF",
    footerBackground: "#FFFFFF",
    clearButtonText: "#2F8EDB",
    applyButtonBackground: "#2F8EDB",
    applyButtonHoverBackground: "#1C78C2",

    triggerClearText: "#FFA200",
    triggerBadgeText: "#FFFFFF",
  },

  dateFilter: {
    triggerHoverBackground: "#D4ECFA",
    triggerText: "#39ACE7",
    triggerTextActive: "#003771",

    popoverBackground: "#FFFFFF",
    popoverText: "#000000",
    popoverBorder: "#E6E6E6",
    popoverShadow: "0 4px 18px rgba(0,0,0,0.15)",

    presetPanelBackground: "#FBFDFF",
    presetText: "#000000",
    presetHoverBackground: "#39ACE733",
    presetSelectedBackground: "#39ACE733",
    presetArrow: "#39ACE7",

    calendarBackground: "#EFF6FF",
    calendarHeaderText: "#000000",
    weekDayText: "#000000",

    rangeBackground: "#39ACE7",
    dayText: "#000000",
    dayTextInRange: "#FFFFFF",
    dayHoverBackground: "#D4ECFA",
    dayHoverText: "#000000",
  },

  search: {
    background: "#6C727F",
  },

  accordion: {
    bg: "#EFF6FF",
  },
  modal: {
    bg: "#EFF6FF",
    text: "#000000",
    subTitle: "#003771",
    // new colors for pepwise 2.0 modal
    titleBg: "#003771",
    title: "#FFFFFF",
    background: "#FFFFFF"
  },
  overlay: {
    // new colors for pepwise 2.0 overlay
    title: "#00366E",
    IconColor: "#00366E",
    border: "#71758FCC",
    background: "#FFFFFF"
  },
  input: {
    border: "#fff",
    text: "#fff",
    borderFocus: "#003771",
  },

  // This is for the new input fields in the pepwise 2.0
  inputNew: {
    inputBackground: '#EFF6FF',
    inputBorder: '#71758FCC',
    inputBorderHover: '#39ACE7',
    inputBorderFocus: '#003771',
    inputIcon: '#39ACE7',
    inputText: '#000000',
    inputPlaceholder: '#71758F',
    labelText: '#000000',
    addText: '#39ACE7',
    saveBackground: '#39ACE7',
    saveText: '#FFFFFF',
    removeBorder: '#FE2626',
    removeHoverBackground: '#FE262733',
    removeIcon: '#FE2626',
    error: '#FE2626',
  },

  // This is for the new toggle in the pepwise 2.0
  toggle: {
    text: '#000000',
    thumb: '#FFFFFF',
    trackOff: '#71758F',
    trackOn: '#39ACE7',
    disabledTrack: '#A9ADCB',
    thumbShadow: '0px 1px 3px rgba(0, 0, 0, 0.25)',
  },

  chip: {
    activeBg: "#01C00826",
    inactiveBg: "#D82B5133",
    textPrimary: "#000000",
  },

  richTextEditor: {
    icons: {
      primary: "#fff",
    }
  },

  buttons: {
    primary: {
      color: "#009BD8", // used in modals
      bgColor: "#0784B5",
      bgColorSecondary: "#003771",
      text: "#FFFFFF",
      // pepwise 2.0 button colors
      solidBg: '#39ACE7',
      solidText: '#FFFFFF',
      solidHoverBg: '#009BD8',
      borderedText: '#009BD8',
      borderedBorder: '#009BD8',
      borderedHover: '#003771',
      borderedHoverText: '#003771',
      textColor: '#009BD8',
      textHover: '#003771',
      disabledBg: '#A9ADCB',
      disabledSolidText: '#D9D9D9',
      disabledText: '#A9ADCB',
      disabledBorder: '#A9ADCB',
    }
  },

  Tab: {
    Active: {
      bgColor: "#004894",
      color: "#ffffff",
      colorSecondary: "#003771",

      newBgColor: "#ffffff",
      newColor: "#009BD8",
      newBorderColor: "#009BD8"
    },

    inActive: {
      bgColor: "#003771",
      color: "#A6ABCA ",
      colorSecondary: "#009BD8",

      newColor: "#ffffff",
    }
  },

  dataPipeline: {
    accordionWidget: {
      accordionHeader: {
        background: '#FBFDFF',
        text: '#000000',
        tooltipBackground: '#FFFFFF',
        tooltipText: '#000000',
        tooltipTitle: '#71758F',
        tooltipArrow: '#FFFFFF',
        comingSoonBackground: '#A9ADCB',
        comingSoonBorder: '#A9ADCB',
        legendText: '#A9ADCB',
        expandIconActive: '#000000',
        expandIconInactive: '#39ACE7',
      },
      background: {
        page: '#EFF6FF',
        card: '#FFFFFF',
        tooltip: '#EFF6FF',
        statusMuted: '#A9ADCB',
        runningDayActive: '#003771',
        timelineBar: '#003771',
        timelineDotBorder: '#FFFFFF',
        timelineDotRing: '#00000033',
        timelineConnector: '#FFFFFF',
      },
      text: {
        primary: '#000000',
        secondary: '#71758F',
        inverse: '#FFFFFF',
        link: '#39ACE7',
        tooltipPrimary: '#003771',
      },
      border: {
        subtle: '#D3D7DE',
        muted: '#A9ADCB',
        runningDay: '#003771',
        expandedAccordion: '#39ACE7',
      },
      pagination: {
        iconActive: '#39ACE7',
        iconDisabled: '#A9ADCB',
        pageActiveBackground: '#71758F33',
        pageActiveText: '#39ACE7',
        pageDefaultText: '#39ACE7',
        pageHoverBackground: '#71758F33',
      },
      timelineTooltip: {
        background: '#EFF6FF',
        text: '#000000',
        shadow: '0px 8px 24px #00000033',
      },
    },
  },

  widget: {
    text: {
      main: '#fff',
      title: '#fff',
      value: '#fff',
      changeUp: '#D82B51',
      changeDown: '#01C008',
      noChange: '#ffffff',
      duplicateCount: '#FFA200',
      action: {
        primary: '#009BD8',          // ADD PROJECT text/icon + link hover
        primaryHover: '#009BD8',     // (same for now, keep for future flexibility)
      },
    },
    background: {
      card: '#71758F',
      chart: '#71758F',
    },
    chart: {
      emptyCircleFill: '#71758f66',
      labelColor: '#FFFFFF', // piechart label
      legendTextColor: '#ffffff',
      legendActiveUpDownIconColor: '#000000',
      legendInactiveUpDownIconColor: '#A7ADCB',
      tooltipBg: '#000000',
      tooltipText: '#ffffff',
      labelColorSecondary: '#ffffff', // barchart label
    },
    gaugeChart: {
      filledArcColor: "#299BFF",
      unfilledArcColor: "#E4EDFF",
    },
    colors: {
      color1: "#00B4C5",
      color2: "#00BF7D",
      color3: "#F57600",
      color4: "#F5359E",
      color5: "#FF6B55",
      color6: "#8BABF1",
      color7: "#1F4E79",
      color8: "#3FA9F5",
      color9: "#A6C8E1",
      trendLine: "#FDB515"
    },
    tab: {
      activeBorderColor: "#12386D",
      inActiveBorderColor: "#5A97BF ",
      active: {
        color: "#12386D",
      },
      inActive: {
        color: "#5A97BF ",
      }
    },
    filter: {
      bgColorPrimary: '#A7ADCB',
      bgColorSelected: '#12386D',
      textSelected: '#fff',
      textPrimary: '#5A97BF',
      border: '#5A97BF',
    },
    sla: {
      missed: {
        bg: 'rgba(216, 43, 81, 1)',
        hoverBg: 'rgb(189, 29, 64)',
      },
      met: {
        bg: 'rgba(1, 192, 8, 1)',
        hoverBg: 'rgb(3, 168, 8)',
      },
      scheduled: {
        bg: 'rgba(169, 173, 203, 1)',
        hoverBg: 'rgba(163, 168, 200, 1)',
      },
      progress: {
        bg: 'rgba(236, 185, 20, 1)',
        hoverBg: 'rgba(236, 185, 20, 1)',
      },
      others: {
        bg: 'rgba(236, 185, 20, 1)',
        hoverBg: 'rgb(220, 171, 10)',
      },
      text: '#FFFFFF', // SLA button text color
    },
  },

  KpiSeverityWidget: {
    severity: {
      critical: '#F04438',
      major: '#F79009',
      minor: '#EAAA08',
      warning: '#FFCC00',
      info: '#2E90FA',
      healthy: '#01C008',
      Acknowledged: "#A9ADCB",
      Unacknowledged: "#9498B5"

    },

    card: {
      background: '#FFFFFF',
      highlightBackground: '#003771',
      border: 'rgba(0, 0, 0, 0.12)',
      shadow: '0 1px 2px rgba(0, 0, 0, 0.06)',
      hoverShadow: '0 4px 14px rgba(0, 0, 0, 0.10)',
    },

    text: {
      primary: '#0A0A0A',
      secondary: '#BAB5B5',
      muted: '#888888',
      disabled: '#CCCCCC',
      highlight: '#FFFFFF',
      highlightSecondary: 'rgba(255, 255, 255, 0.70)',
      highlightMuted: 'rgba(255, 255, 255, 0.65)',
      link: '#43A5F0',
    },

    alertRow: {
      background: 'rgba(0, 0, 0, 0.04)',
      highlightBackground: '#003771',
      platformHighlightBackground: 'rgba(255, 255, 255, 0.12)',
    },

    kpi: {
      background: '#F0F4FA',
      highlightBackground: '#003771',
    },

    segment: {
      background: '#FFFFFF',
      highlightBackground: 'rgba(255, 255, 255, 0.08)',
      border: 'rgba(0, 0, 0, 0.06)',
      highlightBorder: 'rgba(255, 255, 255, 0.15)',
      text: '#FFFFFF',
    },

    dialog: {
      background: '#FFFFFF',
      title: '#FFFFFF',
      closeIcon: '#FFFFFF',
    },
  },

  kpiTile: {
    text: {
      main: '#ffffff',
      title: '#ffffff',
      value: '#ffffff',
      changeUp: '#D82B51',
      changeDown: '#01C008',
      noChange: '#ffffff'
    },
    background: {
      card: '#71758F',
      selected: '#009BD8',
      border: '#CAE9F5',
      hover: '#c0c1c4ff',
      changeUp: '#FFC5C2',
      changeDown: '#AEFFB8',
      steady: '#FFEAC6'

    },
  },

  tooltip: {
    text: {
      primary: '#ffffff',
      title: '#ffffff',
      description: '#ffffff',
    },
    background: {
      primary: '#000000',
    },
    button: {
      BgColor: '#009BD8',
      textPrimary: '#ffffff',
      textSecondary: '#003771',
    },
    progressDot: {
      primary: '#009BD8', // active
      secondary: '#D0D0D0', // inactive
    }
  },

  table: {
    headerText: '#fff',
    text: '#fff', // row text color
    title: '#fff',
    headerBg: '#6C727F',
    oddRowBgColor: '#0F172A',
    evenRowBgColor: '#020617',
    moreIcon: '#fff',
    highlightRowBgColor: '#003771',
    chipBackground: "#39ACE733",
    chipText: "#003771",
    expandIcon: "#003771",
    pagination: {
      text: '#000',
      pageSizeText: '#fff',
      BgColor: '#51535bff',
      arrow: '#000',               // Arrow (next/prev, first/last) color
      selectedText: '#000000',        // Text color for selected page
      selectedBackground: '#71758F33',// Background for selected page
      hoverBackground: '#71758F33',   // Background on hover
    }
  },

  toast: {
    success: {
      title: '#01C008',
      icon: '#01C008',
    },
    alert: {
      title: '#F58A1F',
      icon: '#FD9532',
    },
    error: {
      title: '#FF3B30',
      icon: '#FB3836',
    },
    background: '#EFF6FF',
    message: '#001E3E',
    closeIcon: '#001E3E',
  },

  login: {
    background: {
      default: "#000",
      textFieldBackground: "rgba(255, 255, 255, 0.5)",
      button: "#EB3323",
    },
    text: {
      main: "#FFFFFF",
      tagLine: "#E5E5E5",
      forgot: "#39ACE7",
    },
  },

  white: {
    main: "#ffffff",
    button: "#ffffff",
    srch: "#000000",
    focus: "#00B9FF",
  },
  text: {
    subtle: '#a9adcb',
    main: "#E5E5E5",
    focus: "#00B9FF",
    dark: "#121212",
  },
  primary: {
    main: "#003771",
    focus: "#0079A6",
    dark: '#122950',
  },

  secondary: {
    main: "#00B9FF",
    focus: "#990F0F",
  },

  info: {
    main: "#00B9FF",
    focus: "#32990F",
  },

  success: {
    light: '#00d08d',
    main: "#00a556",
    focus: "#00B9FF",
    state: "#43CC14",
  },

  warning: {
    main: "#fd7b33",
    focus: "#fd7b33",
  },

  error: {
    main: "#FE2626",
    focus: "#F21818",
  },

  light: {
    main: "#8c8c8c",
    diff: "#BCBCBC",
    focus: "#00B9FF",
    unselected: "#8c8c8c",
  },

  dark: {
    main: "#8C8C8C",
    focus: "#00B9FF",
    unselected: "#8c8c8c",
    helpBorder: "#fff",
    background: "#121212",
    text: "#404040",
    dark: "#A9ADCB33",
  },
  gradients: {
    primary: commonColor.gradients.primary,
    secondary: commonColor.gradients.secondary,
    success: commonColor.gradients.success,
    sidenav: commonColor.gradients.sidenav,
    error: commonColor.gradients.error,
    info: {
      main: "#0A68F3",
      state: "#00B9FF",
    },
    warning: {
      main: "#8ce0ff",
      state: "#8ce0ff",
    },
    light: {
      main: "#fdc4a4",
      state: "#f0ae89",
    },

    dark: {
      main: "#8c8c8c4d",
      state: "#2929294d",
    },
  },
  boxColor: {
    green: {
      color: 'rgb(70, 254, 77)',
      bgColor: 'rgba(1, 154, 6, 0.7)',
    },
    red: {
      color: 'rgb(254, 52, 52)',
      bgColor: 'rgba(181, 1, 1, 0.7)',
    },
    orange: {
      color: 'rgb(255, 171, 26)',
      bgColor: 'rgba(204, 130, 0, 0.7)',
    },
    orangeDark: {
      color: 'rgba(253, 120, 59, 1)',
      bgColor: 'rgba(253, 120, 59, 0.7)',
    },
    blue: {
      color: 'rgb(54, 168, 255)',
      bgColor: 'rgba(0, 96, 179, 0.7)',
    },
    gray: {
      color: 'rgb(163, 178, 199)',
      bgColor: 'rgba(50, 54, 83, 0.7)',
    },
    default: {
      color: 'rgba(169, 173, 203)',
      bgColor: 'rgba(169, 173, 203, 0.2)',
    },
    paleYellow: {
      color: 'rgba(252, 192, 70, 1)',
      bgColor: 'rgba(252, 192, 70, 0.7)'
    },
    paleRed: {
      color: 'rgba(255, 137, 137, 1)',
      bgColor: 'rgba(255, 137, 137, 0.7)'
    },
    paleGray: {
      color: 'rgba(169, 173, 203, 1)',
      bgColor: 'rgba(169, 173, 203, 0.7)'
    },
    lime: {
      color: 'rgba(183, 207, 72, 1)',
      bgColor: 'rgba(183, 207, 72, 0.7)'
    },
    pgmGreen: {
      color: 'rgba(1, 192, 8, 1)',
      bgColor: 'rgba(1, 192, 8, 0.7)'
    },
    pgmPink: {
      color: 'rgba(216, 43, 81, 1)',
      bgColor: 'rgba(216, 43, 81, 0.7)'
    },
    pgmYellow: {
      color: 'rgba(236, 185, 20, 1)',
      bgColor: 'rgba(236, 185, 20, 0.7)'
    },
    purple: {
      color: 'rgba(160, 129, 255, 1)',
      bgColor: 'rgba(160, 129, 255, 0.7)'
    },
    solidBlue: {
      color: 'rgba(41, 155, 255, 1)',
      bgColor: 'rgba(41, 155, 255, 0.7)'
    },
    pgmGray: {
      bgColor: 'rgba(0, 30, 62, 1)',
      color: 'rgba(169, 173, 203, 1)',
    }
  },
};
